
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTargetTrackedDangerousIec as ObiRadarTargetTrackedDangerousIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-target-tracked-dangerous-iec.js';
 
 
 

 
 export const ObiRadarTargetTrackedDangerousIec = createComponent({
   react: React,
   tagName: 'obi-radar-target-tracked-dangerous-iec',
   elementClass: ObiRadarTargetTrackedDangerousIecElement,
   events: {
     
   }
  });
 
 